exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".map-scroll-text {\n  margin: 0;\n  overflow: hidden;\n  color: rgba(255,255,255,0.5);\n}\n", ""]);
